<template>
    <div style="background:#f0f9fd;">
        <div class="lefttop"><span></span>云验证</div>    
        <dl class="leftmenu">
            <dd v-for="parent,index in parentList">
                <div class="title" @click="activeM(parent,index)"><span><img :src="parent.img" /></span>{{parent.name}}</div>
                <ul class="menuson" v-show="parent.isOpen">
                    <li v-for="child,cindex in parent.childList" :class="{active:child.isActive}" @click="activeFun(child)">
                        <cite></cite><a :href="child.url" target="rightFrame">
                            {{child.name}}
                        </a>
                    </li>
                </ul>
            </dd>
        </dl>
    </div>
</template>
<script>
import txlIco from '@/assets/images/leftico01.png';
export default {
    data(){
        return{
            parentList:[{
                name:'产品介绍',
                img: txlIco,
                isOpen:true,
                childList:[
                    {name:'网商总机',url:'/wszj_introduction', isActive: true},
                    {name:'400电话',url:'/phone400introduction', isActive: false},
                    {name:'短信包/彩信宝',url:'/smsmmsintroduction', isActive: false},
                    {name:'电子传真',url:'/faxintroduction', isActive: false},
                    {name:'长话宝',url:'/changhuabaointroduction', isActive: false},
                    {name:'电话会议',url:'/meetingintroduction', isActive: false},
                    {name:'语音短信',url:'/voicesmsintroduction', isActive: false},
                    {name:'API业务',url:'/apiintroduction', isActive: false},
                ]
            }]
        }
    },
    methods:{
        activeFun: function(data){
            this.parentList.forEach(function(obj){
                 obj.childList.forEach(function(cobj){
                    cobj.isActive = false;   
                });
            });
            
            data.isActive = !data.isActive;
        },
        activeM: function(data,selecIndex){
            this.parentList.forEach(function(obj,index){
                if(index != selecIndex)
                    obj.isOpen = false;
            });
            data.isOpen = !data.isOpen;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shouye/productleft.vue